export const WHATSAPP_URL = "https://wa.me/351915668325";

export const PROMO_WHATSAPP_URL =
  "https://wa.me/351915668325?text=" +
  encodeURIComponent("Olá! Quero agendar a promoção do Design de Sobrancelhas por 10€");

export const MAPS_URL = "https://share.google/EGThnXxKSbpRpWB4s";

export const ADDRESS =
  "R. Capitão Mouzinho de Albuquerque 18, 2º Andar D — Centro, 2400-193 Leiria";

export const PHONE_DISPLAY = "915 668 325";

export const SPECIALTIES = [
  {
    number: "01",
    title: "Nails Designer",
    description:
      "Unhas de gel, fibra e blindagem com acabamento natural e alta durabilidade. Precisão técnica em cada milímetro.",
    image: "/assets/nails.webp",
    tag: "UNHAS",
  },
  {
    number: "02",
    title: "Design de Sobrancelhas",
    description:
      "Mapeamento facial personalizado e simetria perfeita. O desenho certo para a geometria do seu rosto.",
    image: "/assets/browdesign.webp",
    tag: "SOBRANCELHAS",
  },
  {
    number: "03",
    title: "Brow Lamination",
    description:
      "Fios alinhados, encorpados, nutridos e com caimento impecável. Efeito penteado que dura semanas.",
    image: "/assets/browlamination.webp",
    tag: "BROW",
  },
  {
    number: "04",
    title: "Lash Lifting",
    description:
      "Curvatura, elevação e destaque para os seus cílios naturais — sem extensão, sem artifício.",
    image: "/assets/lashlift.webp",
    tag: "OLHAR",
  },
];
